export default __webpack_public_path__ + "static/media/loyalty-icon.7c5d3105.svg";